import { useRepositoryMutation, useRepositoryQuery } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { Spinner, Stack } from '@optimus-web/core';
import { AuthorizedDeviceList } from '../../../../auth';
import { SecuritySubsection } from '../SecuritySubsection';

export function TrustedDeviceList() {
    const { data, isPending: isFetchingPending } = useRepositoryQuery('users', 'getCurrent', {});
    const { mutate: onUserRemove, isPending: isMutationPending } = useRepositoryMutation(
        'deviceAuthorization',
        'unauthorizeOwnDevice',
        { invalidateQueries: { users: ['getCurrent'] } }
    );

    if (isFetchingPending) {
        return (
            <Stack itemAlignment="center">
                <Spinner />
            </Stack>
        );
    }

    if (data?.userDevices?.length === 0) {
        return null;
    }

    return (
        <SecuritySubsection title={TextKey.AuthorizedDevicesSectionTitle}>
            <AuthorizedDeviceList
                isPending={isMutationPending}
                devices={data?.userDevices}
                currentDeviceId={data?.currentDeviceId}
                onUserRemove={(deviceId) => onUserRemove({ deviceId })}
            />
        </SecuritySubsection>
    );
}
